import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import { ConfigService } from "../config/config.service";
import { EventsService } from "../event/event.service";
import Cookies from "js-cookie";
declare var window: any;

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  public memoryStorage = new Map();
  constructor(
    public config: ConfigService,
    public platform: Platform,
    private eventService: EventsService
  ) { }

  setCampaignId(code) {
    this.memoryStorage.set("campaignId", code);
  }

  getCampaignId() {
    return this.memoryStorage.get("campaignId");
  }

  removeCampaignId() {
    this.memoryStorage.delete("campaignId");
  }

  // clones the array for immutability
  clone(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.clone(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }

  escapeSpecialCharacters(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

  isIosApp() {
    return this.platform.is("capacitor") && this.platform.is("ios");
  }

  getHashParam(name) {
    if ("undefined" === typeof parent.location.hash) return null;
    var hash = parent.location.hash.substr(1);
    var value = hash.substr(hash.indexOf(name + '=')).split('&')[0].split('=')[1];
    if (value) return value;
    return null;
  }

  getUrlParams(queryString = null) {
    // get query string from url (optional) or window
    if (queryString === null) {
      queryString = parent.window.location.search.slice(1);
    }

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {
      // split our query string into its component parts
      var arr = queryString.split("&");

      for (var i = 0; i < arr.length; i++) {
        // separate the keys and the values
        var a = arr[i].split("=");

        // in case params look like: list[]=thing1&list[]=thing2
        var paramNum = undefined;
        var paramName = a[0].replace(/\[\d*\]/, function (v) {
          paramNum = v.slice(1, -1);
          return "";
        });

        // set parameter value (use 'true' if empty)
        var paramValue = typeof a[1] === "undefined" ? "" : a[1];

        // (optional) keep case consistent
        paramName = paramName.toLowerCase();
        ////paramValue = paramValue.toLowerCase();

        // if parameter name already exists
        if (obj[paramName]) {
          // convert value to array (if still string)
          if (typeof obj[paramName] === "string") {
            obj[paramName] = [obj[paramName]];
          }
          // if no array index number specified...
          if (typeof paramNum === "undefined") {
            // put the value on the end of the array
            obj[paramName].push(paramValue);
          }
          // if array index number specified...
          else {
            // put the value at that index number
            obj[paramName][paramNum] = paramValue;
          }
        }
        // if param name doesn't exist yet, set it
        else {
          obj[paramName] = paramValue;
        }
      }
    }

    return obj;
  }

  /*
   * param Title
   *
   */
  /**
     * Updates the url with a new pathname ex: kindred.com/pathname
     *
     * @param {string}   pathname      Ex: casino, promotions
     * @param {string}   [title=""]    Changing the document title, empty by default
     * @param {Object} objectVar     Description.

     */
  pushHistoryState(pathname, title = "") {
    //used for both mobile and web
    // if(!this.isMobileApp()) {
    // let newurl = window.location.protocol + "//" + window.location.host + '/' + pathname.toLowerCase() + window.location.hash;
    let newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      "/" +
      pathname.toLowerCase();
    history.pushState({ path: newurl }, title, newurl);
    this.eventService.publish("event:history:push", { url: newurl });
    // }
  }

  cache_buster() {
    return "undefined" !== typeof window["CACHE_BUSTER"]
      ? window["CACHE_BUSTER"]
      : null;
  }

  reverseDate_YYYY_MM_DD(date) {
    let yyyy = date.slice(6, 10);
    let mm = date.slice(0, 2);
    let dd = date.slice(3, 5);

    let str = yyyy + "-" + mm + "-" + dd;

    return str;
  }


  /**
   * look for cookie named 'affiliate-data'
   */
  getCookieParams(name) {
    return Cookies.get(name);
  }

  setCookie(name, value,
    config?: { path?: string, domain?: string, expires?: number | Date, secure?: boolean, sameSite?: 'strict' | 'no_restriction' | 'lax' }) {
    Cookies.set(name, value, config);
  }

  removeCookie(key: string, attributes?: any) {
    Cookies.remove(key, attributes);
  }

  getCDNAsset(path) {
    if (path?.charAt(0) == "/") path = path?.substring(1);

    if (undefined !== path) {
      if (undefined !== typeof this.config.getConfig().CDN_BASEURL) {
        return (
          this.config.getConfig().CDN_BASEURL +
          "/assets/" +
          `${path}?v=${this.cache_buster()}`
        );
      } else {
        return "";
      }
    }
  }

  getDepositCDNAAsset(path): string {
    const cdnBaseURL = this.config.getConfig().CDN_BASEURL;
    if (undefined !== path) {
      if (undefined !== typeof cdnBaseURL) {
        return cdnBaseURL + "/assets/imgs/" + `${path}?v=${this.cache_buster()}`;
      }
      return "";
    }
  }

  getDepositConfigCDNAsset(path): string {
    const cdnBaseURL = this.config.getConfig().CDN_BASEURL;
    if (undefined !== path) {
      if (undefined !== typeof cdnBaseURL) {
        return cdnBaseURL + "/assets/" + path;
      }
      return "";
    }
  }

  loadCDNDepositAsset(path) {
    const cdnURL: string = this.config.getConfig().CDN_BASEURL;

    let fromCDN = `${cdnURL}/${path}?v=${this.cache_buster()}`;
    return this.cache_buster() != null || this.platform.is("cordova")
      ? fromCDN
      : path;
  }

  removeUrlParams() {
    var clean_uri =
      location.protocol + "//" + location.host + location.pathname;
    window.history.replaceState({}, document.title, clean_uri);
  }

  public isQualified(customrQualification) {
    let data = customrQualification.payload;
    let pageToNavigate;

    let response: any = {
      result: true,
      pageToNavigate: pageToNavigate,
    };

    if (!!data) {
      switch (data["policy-name"]) {
        case "emailvalidation":
          pageToNavigate = "InvalidEmailPage";
          break;
        case "kyc":
          pageToNavigate = "InvalidKycPage";
          break;
        case "spincriteria":
          pageToNavigate = "InvalidSpinPage";
          break;
      }
      response = {
        result: false,
        pageToNavigate: pageToNavigate,
      };
    }
    return response;
  }

  public isURL(url: string): boolean {
    if (!~url.indexOf("http") || !~url.indexOf("www")) return false;
    return true;
  }

  public getDomain() {
    var hostname = document.domain;

    if (hostname != null) {
      var parts = hostname.split(".").reverse();

      if (parts) {
        var domain = parts[0];
        for (let partscount = 1; partscount < parts.length - 1; partscount++) {
          domain = parts[partscount] + "." + domain;
        }
      }
    }

    return domain;
  }

  getMainDomain() {
    const ipaddressReg = /(\d{1,3}\.){3}\d{1,3}/;
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || ipaddressReg.test(hostname)) {
      return hostname;
    } else {
      const mainDomain = window.location.hostname.split('.').slice(-2)

      return mainDomain.join('.')
    }
  }

  //removing the "/" in the url "/url/"=> url
  public cleanPathName(pageName) {
    if (pageName[0] == "/") pageName = pageName.substring(1);
    if (pageName[pageName.length - 1] == "/") pageName = pageName.substring(0, pageName.length - 1);
    return pageName;
  }

  /**
 * return the value of the property from the given object regardless of case of the property name
 */
  getInsensitiveProp(o: any, propName: string) {
    propName = ("" + propName).toLowerCase();
    for (var k in o) {
      if (o.hasOwnProperty(k) && (propName == ("" + k).toLowerCase())) {
        return o[k];
      }
    }
    return null;
  }

  //Format the seconds to display for different bonus type
  formatTime(secs: number): string {
    if (secs) {
      var hours: number | string = Math.floor(secs / 3600);
      var minutes: number | string = Math.floor((secs - (hours * 3600)) / 60);
      var seconds: number | string = secs - (hours * 3600) - (minutes * 60);

      if (hours < 10) { hours = "0" + hours; }
      if (minutes < 10) { minutes = "0" + minutes; }
      if (seconds < 10) { seconds = "0" + seconds; }
      return hours + ':' + minutes + ':' + seconds;
    } else {
      return "";
    }
  }

    //Format the seconds to display for hourly bonus type
    formatTimeHourlyBonus(secs: number): string {
      if (secs) {
        var hours: number | string = Math.floor(secs / 3600);
        var minutes: number | string = Math.floor((secs - (hours * 3600)) / 60);
        var seconds: number | string = secs - (hours * 3600) - (minutes * 60);
  
        if (hours < 10) { hours =  hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        return hours + ':' + minutes + ':' + seconds;
      } else {
        return "";
      }
    }

  //Format the seconds to display for different bonus type
  formatTimeInDHMS(ms: number): string {
    let secs = ms/1000;
    if (secs) {
      var days: number | string = Math.floor(secs/86400);
      var hours: number | string = Math.floor((secs - days * 86400) / 3600);
      var minutes: number | string = Math.floor((secs - days * 86400 - hours * 3600) / 60);
      var seconds: number | string = Math.floor(secs - days * 86400 - hours * 3600 - minutes * 60);

      if (days < 10) { days  =  days +" DAY"; } else { days = days + " DAY"; }
      if (hours < 10) { hours = hours +" HRS"; }  else { hours = hours + " HRS"; }
      if (minutes < 10) { minutes =  minutes + " MIN"; } else { minutes = minutes + " MIN"; }
      if (seconds < 10) { seconds =  seconds +" SEC"; } else { seconds = seconds + " SEC"; }
      return days + ' ' +hours + ' ' + minutes + ' '  + seconds;
    } else {
      return "";
    }
  }

    //Format the seconds to display for different bonus type
    formatTimeInDHMSIndependent(ms: number): any {
      let secs = ms/1000;
      if (secs) {
        var days: number | string = Math.floor(secs/86400);
        var hours: number | string = Math.floor((secs - days * 86400) / 3600);
        var minutes: number | string = Math.floor((secs - days * 86400 - hours * 3600) / 60);
        var seconds: number | string =  Math.floor(secs - days * 86400 - hours * 3600 - minutes * 60);

        if (days < 10) { days  =  days  } 
        if (hours < 10) { hours =  hours } 
        if (minutes < 10) { minutes =  minutes  } 
        if (seconds < 10) { seconds =  seconds  }
        let obj = {
          days : days,
          hours: hours,
          minutes: minutes,
          seconds: seconds
        }
        return obj;
      } else {
        return "";
      }
    }

  percentageFormatter(num) {
    let formatted = new Intl.NumberFormat('default', {
      style: 'percent',
      minimumFractionDigits: 5,
      maximumFractionDigits: 5
    }).format(num);
    if (formatted) {
      formatted = formatted.replace(/(\.\d*?[1-9])0+|\.0*$/, '$1');
      if (formatted.endsWith('.00000%')) {
        formatted = formatted.slice(0, -4) + '%';
      }
    }
    return formatted;
  }

    
}
